/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Group580.css";

function Group580(props) {
  const { path691, path692, className } = props;

  return (
    <div className={`group-580 ${className || ""}`}>
      <div className="group-579">
        <div className="group">
          <div className="group-574">
            <div className="group-573">
              <div className="group">
                <div className="group-561"></div>
                <div className="group-566"></div>
                <div className="group-569"></div>
                <div className="group-572"></div>
                <img className="path-691" src={path691} />
                <img className="path-692" src={path692} />
              </div>
            </div>
          </div>
          <div className="group-578"></div>
        </div>
      </div>
    </div>
  );
}

export default Group580;
